module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_5.051052d8.png";